




























































import { Component, mixins } from '@niknevis/vue-modules'
import { ModelSync, Prop } from 'vue-property-decorator'
import { VirtualScrollPaginatableMixin } from '@/modules/shared/mixins/virtual-scroll-paginatable.mixin'
import { SearchablePaginatableMixin } from '@/modules/shared/mixins/searchable-paginatable.mixin'
import {
  SearchEntityItemsPaginatedUseCase
} from '@/modules/common/entity-search/use-cases/search-entity-items-paginated.use-case'
import { isArray } from '@/modules/shared/helpers/utils/utils'
import { debounce } from '@/modules/shared/helpers/decorators/debounce'

@Component
export default class EntitySearchSelect extends mixins<VirtualScrollPaginatableMixin<any>,
  SearchablePaginatableMixin<any>>(VirtualScrollPaginatableMixin, SearchablePaginatableMixin) {
  constructor(
    private readonly useCase: SearchEntityItemsPaginatedUseCase<any>
  ) {
    super()
  }

  @ModelSync('value', 'input', { default: () => [] })
  selectedItems!: object[] | number

  @Prop({ required: true }) route!: string
  @Prop({ required: true }) optionLabel!: string
  @Prop({ default: 'id' }) optionValue: string
  @Prop({ default: false }) lazy: boolean
  @Prop({ default: () => [] }) defaultSelected: number[]
  @Prop({ default: 'هیچ ایتمی پیدا نشد' }) noOptionMessage: string
  @Prop({ default: 'انتخاب کنید' }) placeholder: string
  @Prop({ default: false }) multiple: boolean
  @Prop() loadAll: boolean
  @Prop() minimumCharacter: number //Minimum 2 characters to trigger filtering
  @Prop({ default: () => ({}) }) params: Record<string, string | number>
  @Prop({ default: false }) noEmitValue: boolean

  private defaultSelectedValue = this.defaultSelected

  private collection = this.useCase.execute(this.route, this.getItemsQSParams)

  private get getPlaceholder() {
    return this.isSelected ? '' : this.placeholder
  }

  get useInput() {
    return !(this.isSelected && this.loadAll)
  }

  get paginatable() {
    //@ts-ignore
    if (this.collection.value) this.$emit('getReserves', this.collection)
    return this.collection
  }

  protected get loading() {
    return this.paginatable.isInProgress()
  }

  private get getItemsQSParams() {
    if (this.defaultSelectedValue) {
      return {
        ...this.params,
        selected: this.defaultSelectedValue,
        per_page: this.loadAll ? Number.MAX_SAFE_INTEGER : undefined
      }
    }
    return {
      ...this.params,
      per_page: this.loadAll ? Number.MAX_SAFE_INTEGER : undefined
    }
  }

  private get options() {
    return this.paginatable.fold(
      () => [],
      value => value ? value.data : [],
      value => {
        if (this.defaultSelectedValue) {
          this.$nextTick(() => {
            this.selectedItems = this.multiple
              ? value.data
                .filter(item => this.defaultSelected.includes(item[this.optionValue]))
                .map(item => item[this.optionValue])
              : value.data.find(item => this.defaultSelected.includes(item[this.optionValue]))?.[this.optionValue] || null
            this.defaultSelectedValue = null
          })
        }
        return value.data
      },
      error => []
    )
  }

  get isSelected() {
    return isArray(this.selectedItems)
      //@ts-ignore
      ? !!this.selectedItems.length
      : !!this.selectedItems
  }

  @debounce(1000)
  private onFilter(value, update, abort) {

    if (this.minimumCharacter && value.length < this.minimumCharacter) {
      abort()
      return
    }

    this.search(value, (() => {
      update()
    }))

    update()
  }

  mounted() {
    if (this.defaultSelected.length || !this.lazy) {
      this.paginatable.next(this.getItemsQSParams).then(paginate => {
        //@ts-ignore
        const selectedItems = paginate.value.data
          .reduce((items, item) => {
            if (this.defaultSelected.includes(item[this.optionValue])) {
              return items.concat(this.noEmitValue ? item : item[this.optionValue])
            }
            return items
          }, [])
        this.selectedItems = this.multiple
          ? selectedItems
          : selectedItems[0] || null
      })
    }
  }
}
